<template>
  <el-select
    :value="value"
    value-key="value"
    filterable
    :multiple="multiple"
    remote
    reserve-keyword
    :collapse-tags="true"
    :placeholder="placeholder"
    :remote-method="remoteRequest"
    :loading="loading"
    @change="onChange"
  >
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item.text"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      default: undefined,
    },
    remoteMethod: {
      type: Function,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入关键词",
    },
  },
  data() {
    return {
      options: [],
      loading: false,
    };
  },
  methods: {
    onChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
    remoteRequest(query) {
      if (query !== "") {
        this.loading = true;
        this.remoteMethod(query)
          .then((data) => {
            this.options = data.map((item) => {
              if (Object.prototype.toString.call(item) !== "[object Object]") {
                return { value: item, text: item };
              } else {
                return item;
              }
            });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.options = [];
      }
    },
  },
};
</script>
